import React, { useState, useEffect, useRef } from 'react';
import './CountrySelector.css';

const CountrySelector = ({ selectedCountry, onSelect, countries }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);
    const searchInputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus();
        }
        if (!isOpen) {
            setSearchTerm('');
        }
    }, [isOpen]);

    const filteredCountries = countries.filter(country =>
        country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        country.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        country.dial_code.includes(searchTerm)
    );

    const handleSelect = (country) => {
        onSelect(country);
        setIsOpen(false);
    };

    return (
        <div className="country-selector-container" ref={dropdownRef}>
            <div
                className="country-selector-button"
                onClick={() => setIsOpen(!isOpen)}
                title={`${selectedCountry.name} (+${selectedCountry.dial_code})`}
            >
                <img
                    src={`/svg/${selectedCountry.code.toLowerCase()}.svg`}
                    alt={selectedCountry.code}
                    className="country-flag"
                />
                <span className="country-code">{selectedCountry.code} (+{selectedCountry.dial_code})</span>
            </div>

            {isOpen && (
                <div className="country-dropdown">
                    <div className="country-search">
                        <input
                            ref={searchInputRef}
                            type="text"
                            placeholder="Ülke ara..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                    <div className="country-list">
                        {filteredCountries.length > 0 ? (
                            filteredCountries.map((country) => (
                                <div
                                    key={country.code}
                                    className={`country-option ${selectedCountry.code === country.code ? 'selected' : ''}`}
                                    onClick={() => handleSelect(country)}
                                >
                                    <img
                                        src={`/svg/${country.code.toLowerCase()}.svg`}
                                        alt={country.code}
                                        className="country-flag"
                                    />
                                    <span className="country-name">{country.name}</span>
                                    <span className="country-dial-code">+{country.dial_code}</span>
                                </div>
                            ))
                        ) : (
                            <div className="country-option" style={{ cursor: 'default', color: '#999' }}>
                                Sonuç bulunamadı
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CountrySelector;
